/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import Layout from '../../components/Layout';

const ProtectedRoute = ({ component: Component, render, allowedRoles = [], noLayout = false, ...rest }) => {
  const token = localStorage.getItem('token');

  const renderPage = (props) => {
    const { location } = props;
    const roleStore = localStorage.getItem('user');
    const role = roleStore ? JSON.parse(roleStore).role : null;

    if (!token || !role) {
      return (
        <Redirect
          to={{ pathname: '/login', state: { from: location } }}
        />
      );
    }

    if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
      return (
        <Redirect
          to={{ pathname: '/403', state: { from: location } }}
        />
      );
    }

    const content = render
      ? render(props)
      : Component
      ? <Component {...props} {...rest} />
      : null;

    // If noLayout is true, render content directly without Layout wrapper
    return noLayout ? content : <Layout>{content}</Layout>;
  };

  return <Route {...rest} render={renderPage} />;
};

ProtectedRoute.propTypes = {
  component: PropTypes.func,
  render: PropTypes.func,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  noLayout: PropTypes.bool,
};

export default ProtectedRoute;
